export default __webpack_public_path__ + "static/soehne-web-extraleicht-12571d1a18f6a8e3baf5ed66e276c7aa.woff";